import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0091fec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timer-count-down-root" }
const _hoisted_2 = {
  class: "base",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = { class: "bg" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "bg_path",
  cx: "50",
  cy: "50",
  r: "50"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "trail",
  cx: "50",
  cy: "50",
  r: "45"
}, null, -1))
const _hoisted_6 = ["stroke-dasharray"]
const _hoisted_7 = {
  key: 0,
  class: "no-bet"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t-coin" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "t-coin-img" })
], -1))
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "count" }
const _hoisted_11 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("g", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("path", {
          id: "base-timer-path-remaining",
          "stroke-dasharray": _ctx.progress,
          class: _normalizeClass(["progress", [_ctx.progressColor, { 'no-animate': _ctx.noAnimate }]]),
          d: "\r\n          M 50, 50\r\n          m -45, 0\r\n          a 45,45 0 1,0 90,0\r\n          a 45,45 0 1,0 -90,0\r\n        "
        }, null, 10, _hoisted_6)
      ])
    ])),
    (_ctx.count === -1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t('ingame')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["start-bet", _ctx.timerColor])
        }, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.count), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t('bet')), 1)
        ], 2))
  ]))
}